// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
import MDDatePicker from "components/MDDatePicker";
import { useState } from "react";
import FormField from "components/FormField";

function FilterForm({ getProjects, keyword = "donation" }) {
  const [donation, setDonation] = useState({
    from: "2025-01-01",
    to: "2025-12-31",
    txt: "",
  });

  const onFilterHandller = async () => {
    let filter = "";
    // &filter[_or][8][TransactionDate][_gt]=${donation.from}&filter[_or][9][TransactionDate][_lt]=${donation.to}
    if (donation.txt) {
      filter += `filter[_and][1][TransactionDate][_gt]=${donation.from}&filter[_and][2][TransactionDate][_lt]=${donation.to}&filter[_and][3][_or][1][TxnResult][_contains]=${donation.txt}`;
      if (keyword === "donation")
        filter += `&filter[_and][3][_or][2][country][_contains]=${donation.txt}&filter[_and][3][_or][3][user][_contains]=${donation.txt}&filter[_and][3][_or][4][donation_items][project][_contains]=${donation.txt}`;
      else
        filter += `&filter[_and][3][_or][2][donation_id][country][_contains]=${donation.txt}&filter[_and][3][_or][3][donation_id][user][_contains]=${donation.txt}&filter[_and][3][_or][4][project][_contains]=${donation.txt}`;
    } else if (donation.from && donation.to) {
      filter = `filter[TransactionDate][_gt]=${donation.from}&filter[TransactionDate][_lt]=${donation.to}`;
    }

    getProjects(filter);
  };

  return (
    <Card sx={{ p: 5, mb: 5 }}>
      <Grid container spacing={3} pt={5}>
        <Grid item xs={12} md={4} lg={4}>
          <FormField
            label="المتبرع / البلد / المشروع / رقم الطلب / حالة الطلب"
            placeholder=""
            name="txt"
            value={donation.txt}
            onChange={(e) =>
              setDonation({
                ...donation,
                [e.target.name]: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <MDDatePicker
            onChange={(event, value) =>
              setDonation({
                ...donation,
                from: value,
              })
            }
            value={donation.from}
            name="from"
            input={{
              placeholder: "من",
              fullWidth: true,
            }}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <MDDatePicker
            onChange={(event, value) =>
              setDonation({
                ...donation,
                to: value,
              })
            }
            value={donation.to}
            name="to"
            input={{
              placeholder: "إلى",
              fullWidth: true,
            }}
          />
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <MDButton
            variant="gradient"
            color="dark"
            size="small"
            type="submit"
            onClick={onFilterHandller}
            mx={1}
          >
            + بحث
          </MDButton>
        </Grid>
      </Grid>
    </Card>
  );
}

export default FilterForm;
